const GENERAL_CHAT_TABS = Object.freeze({
  MESSAGES: 'messages',
  PROJECT_CHANNELS: 'channels',
});

export default GENERAL_CHAT_TABS;
